<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="100px"
      :model="formLabelAlign"
    >
      <el-form-item label="账号名称">
        <el-input
          v-model="formLabelAlign.account_name"
          class="inpser"
        />
      </el-form-item>
      <el-form-item label="账号ID">
        <el-input
          v-model="formLabelAlign.account_id"
          class="inpser"
        />
      </el-form-item>
      <el-form-item label="Appid">
        <el-input
          v-model="formLabelAlign.wechat_account_id"
          class="inpser"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="formLabelAlign.note_name"
          class="inpser"
        />
      </el-form-item>

      <!-- <el-form-item label="服务商">
        <el-tag style="margin-right:10px">服务商1</el-tag>
        <el-button
          type="primary"
          size="mini"
          @click="fuwer"
        >选择服务商</el-button>
      </el-form-item> -->
      <el-form-item label="账号状态">
        <!-- <el-input
          v-model="formLabelAlign.account_status"
          class="inpser"
        ></el-input> -->
        <el-radio-group
          v-model="formLabelAlign.account_status"
          size="small"
        >
          <el-radio-button :label="'CUSTOMER_STATUS_NORMAL'">有效</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="账号类型">
        <el-radio-group
          v-model="formLabelAlign.type"
          size="small"
        >
          <el-radio-button :label="1">微信公众号</el-radio-button>
          <!-- <el-radio-button :label="2">腾讯广告（adq）</el-radio-button> -->
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="服务商"
      :visible.sync="dialogVisibleafuwe"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <adfwer ref="adfwerview" />
    </el-dialog>
  </div>
</template>

<script>
import adfwer from './adfwer.vue'
import { advertisers } from '@/api/providerAccountManagement/servicePorviderList'
export default {
  components: { adfwer },
  data() {
    return {
      labelPosition: 'right',
      dialogVisibleafuwe: false,
      formLabelAlign: {
        account_name: '',
        account_id: '',
        note_name: '',
        wechat_account_id: '',
        account_status: 'CUSTOMER_STATUS_NORMAL',
        type: 1
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    send() {
      console.log('弹窗')
    },
    fuwer() {
      this.dialogVisibleafuwe = true
      this.$nextTick(() => {
        this.$refs.adfwerview.send()
      })
    },
    sumbit() {
      if (this.formLabelAlign.account_name === '') {
        this.$message.error('请输入账号名称')
        return
      }
      if (this.formLabelAlign.account_id === '') {
        this.$message.error('请输入账号ID')
        return
      }
      if (this.formLabelAlign.wechat_account_id === '') {
        this.$message.error('请输入Appid')
        return
      }
      if (this.formLabelAlign.note_name === '') {
        this.$message.error('请输入备注')
        return
      }
      advertisers(this.formLabelAlign).then(res => {
        console.log('res', res)
        if (res.code === 0) {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.$emit('updata')
        }
      })
    }
    // async dailist(){

    // }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.inpser {
  width: 300px;
}
</style>
